var render = function render(){var _vm=this,_c=_vm._self._c;return _c('keep-alive',[(_vm.type == 'Admin')?_c('v-container',{staticClass:"d-flex flex-column h-100 pa-0 min-height-inherit",attrs:{"fluid":""}},[_c('div',{staticClass:"d-flex flex-row h-100 pa-0 min-height-inherit"},[_c('side-menu',{staticClass:"hidden-sm-and-down"}),_c('content-section')],1)]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }